var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBrandyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 180,
    viewBox: "0 0 180 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.0898 93C53.4198 113 70.0598 128.8 90.3998 128.8C110.74 128.8 127.38 113 128.71 93",
    stroke: "white",
    strokeWidth: 6,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.09 93C52.03 92.14 52 91.27 52 90.4V59C52 55.134 55.134 52 59 52H121.8C125.666 52 128.8 55.134 128.8 59V90.4C128.8 91.27 128.77 92.14 128.71 93",
    stroke: "white",
    strokeWidth: 6,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52.09 93.0004C52.03 92.1404 52 91.2704 52 90.4004",
    stroke: "white",
    strokeWidth: 6,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M128.801 90.4004C128.801 91.2704 128.771 92.1404 128.711 93.0004",
    stroke: "white",
    strokeWidth: 6,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M90.4004 151.54V128.8",
    stroke: "white",
    strokeWidth: 6,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M66 151.54H114",
    stroke: "white",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M97.02 82.5098H52",
    stroke: "white",
    strokeWidth: 6,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M128.8 82.5098H120.52",
    stroke: "white",
    strokeWidth: 6,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M108.77 94.2598C115.259 94.2598 120.52 88.9991 120.52 82.5098C120.52 76.0204 115.259 70.7598 108.77 70.7598C102.28 70.7598 97.0195 76.0204 97.0195 82.5098C97.0195 88.9991 102.28 94.2598 108.77 94.2598Z",
    stroke: "white",
    strokeWidth: 6,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandyIcon);
export default __webpack_public_path__ + "static/media/brandy-icon.997640779b28a7360e2e994acf20aae0.svg";
export { ForwardRef as ReactComponent };